
import { Card, CardContent } from "@/components/ui/card";

interface TestimonialProps {
  quote: string;
  name: string;
  business: string;
}

const Testimonial = ({ quote, name, business }: TestimonialProps) => {
  return (
    <Card className="h-full">
      <CardContent className="pt-6">
        <div className="text-seo-primary mb-4 text-3xl">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="opacity-40">
            <path d="M11.9999 10.4999C13.6568 10.4999 14.9999 9.15677 14.9999 7.49988C14.9999 5.84299 13.6568 4.49988 11.9999 4.49988C10.343 4.49988 8.99988 5.84299 8.99988 7.49988C8.99988 9.15677 10.343 10.4999 11.9999 10.4999Z"></path>
            <path d="M17.9999 16.6668V14.8334C17.9999 13.5983 17.5255 12.4137 16.6816 11.5313L17.1302 11.8456C16.6794 11.2749 16.103 10.8181 15.45 10.5135L15.9999 10.6668C15.2686 10.3949 14.4736 10.2518 13.6666 10.2518C12.8597 10.2518 12.0646 10.3949 11.3333 10.6668L11.8833 10.5135C11.2303 10.8181 10.6539 11.2749 10.2031 11.8456L10.6516 11.5313C9.80772 12.4137 9.33328 13.5983 9.33328 14.8334V16.6668C9.33328 16.9429 9.44206 17.2075 9.63585 17.4013C9.82964 17.5951 10.0942 17.7038 10.3703 17.7038H17.9629C18.2389 17.7038 18.5035 17.5951 18.6973 17.4013C18.8911 17.2075 18.9999 16.9429 18.9999 16.6668Z"></path>
            <path d="M6.36313 17.5556C6.63898 17.5556 6.86313 17.3314 6.86313 17.0556V15.2222C6.86335 14.147 7.10566 13.0893 7.57166 12.1295C8.03766 11.1698 8.71513 10.3348 9.55313 9.69222C9.77166 9.51889 9.80022 9.20778 9.61646 9.00222C9.43271 8.79667 9.10647 8.77 8.88794 8.94333C7.91335 9.69322 7.12034 10.6678 6.57329 11.7842C6.02623 12.9007 5.74086 14.1316 5.74091 15.3778V17.0556C5.74091 17.3314 5.96506 17.5556 6.24091 17.5556H6.36313Z"></path>
          </svg>
        </div>
        <p className="text-gray-700 italic mb-4">{quote}</p>
        <div className="flex items-center">
          <div className="w-10 h-10 bg-seo-light rounded-full flex items-center justify-center text-seo-primary font-bold">
            {name.charAt(0)}
          </div>
          <div className="ml-3">
            <p className="font-semibold">{name}</p>
            <p className="text-sm text-gray-500">{business}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default Testimonial;
